import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";
import { IPermissionGroup } from "../model/interface/permissionGroup";
import { IPermissionGroupAccess } from "../model/interface/permissionGroupAccess";

export const getAllPermissionGroups = (
  orderByColumn: string,
  sortByDesc: string,
  pageSize: number,
  pageNumber: number
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_PERMISSION_GROUP, {
    params: {
      OrderByColumn: orderByColumn,
      SortDir: sortByDesc,
      PageSize: pageSize,
      PageNumber: pageNumber,
    },
  });
};

export const getPermissionGroupById = (permissionGroupId: number) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_PERMISSION_GROUP_BY_ID}`,
    {
      params: {
        PermissionGroupId: permissionGroupId,
      },
    }
  );
};

export const getAllPermissionGroupAccess = (
  permissionGroupId: number,
  permissionName: string,
  orderByColumn: string,
  sortByDesc: string,
  pageSize: number,
  pageNumber: number
) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_PERMISSION_GROUP_ACCESS}`,
    {
      params: {
        PermissionGroupId: permissionGroupId,
        PermissionName: permissionName,
        OrderByColumn: orderByColumn,
        SortDir: sortByDesc,
        PageSize: pageSize,
        PageNumber: pageNumber,
      },
    }
  );
};

export const getPermissionGroupAccessByGroupId = (
  permissionGroupId: number
) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_PERMISSION_GROUP_ACCESS_BY_ID.replace(
      "{permissionGroupId}",
      permissionGroupId.toString()
    )}`,
    {}
  );
};

export const postPermissionGroup = (permissionGroup: IPermissionGroup) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_PERMISSION_GROUP,
    permissionGroup,
    {}
  );
};

export const postPermissionGroupAccess = (
  permissionGroupAccess: IPermissionGroupAccess
) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_PERMISSION_GROUP_ACCESS,
    permissionGroupAccess,
    {}
  );
};
export const updatePermissionGroupAccess = (
  permissionGroupAccess: IPermissionGroupAccess
) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_PERMISSION_GROUP_ACCESS,
    permissionGroupAccess,
    {}
  );
};
export const updatePermissionGroup = (permissionGroup: IPermissionGroup) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_PERMISSION_GROUP,
    permissionGroup,
    {}
  );
};

export const deletePermissionGroup = (permissionGroupId: number) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_PERMISSION_GROUP, {
    params: {
      PermissionGroupId: permissionGroupId,
    },
  });
};
export const deletePermissionGroupAccess = (
  permissionGroupAccessId: number
) => {
  return AxiosHelper.axiosInstance().delete(
    APIConstant.CMS_PERMISSION_GROUP_ACCESS,
    {
      params: {
        PermissionGroupAccessId: permissionGroupAccessId,
      },
    }
  );
};
